export enum FacebookPrivacyStatus {
  PUBLIC = 'EVERYONE',
  FRIENDS = 'ALL_FRIENDS',
  ONLY_ME = 'SELF',
}

export interface FacebookMetadata {
  privacyStatus: FacebookPrivacyStatus;
}

export const facebookDefaultMetadata: FacebookMetadata = {
  privacyStatus: FacebookPrivacyStatus.PUBLIC,
};
